import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';

@Injectable({
    providedIn: 'root',
})
export class ClicknpayService {
    constructor(private http: HttpClient) {}

    getStatus(checkoutId: string): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}/api/public/payments/click-and-pay-payment-look-up?clientReference=${checkoutId}`
        );
    }
}
